<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester semester-nonall ssystem college department sclass keyword="學號、學生姓名">
                </query>
                <btn-group :load="reload" :input="input"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th>類型</th>
                            <th>學號-學生姓名</th>
                            <th>最後發放日期</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.ScholarshipID">
                        <td data-th="證照補助">{{item.Type|type}}</td>
                        <td data-th="學號-學生姓名"><b-button size="sm" variant="link" @click="edit(item.ScholarshipID)">{{item.StudentNo}}-{{item.StudentName}}</b-button></td>
                        <td data-th="證照補助">{{item.Last|date('yyyy/mm/dd')}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload">
        </Detail>
        <inputmodal id="input" sample="/template/anshin.xlsx" url="/api/scholarshipdetail/excel" @ok="reload()"></inputmodal>
    </page-main>
</template>

<script>
    import Detail from './anshinDetail.vue';

    import { master } from '@/views';
    export default master({
        name: 'scholarship',
        api: '/api/ScholarshipDetail/',
        components: { Detail },
        query: { Type: "Anshin" },
        filters: {
            type: function (value) {
                switch (value) {
                    case "Anshin1": return "強化語言學習";
                    case "Anshin2": return "加強課業輔導";
                    case "Anshin3": return "自律學習";
                    default: return value;
                }
            }
        }
    });
</script>

<style>
</style>